import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from "react";
import { Button, ModalContentBody, ModalContentFooter, ModalContentHeader, Text, } from "@zapier/design-system";
import { useSendFullStoryEvent, useTrackEvent } from "@zapier/toolbox-tracking";
export const ErrorModalView = ({ eventName, fullStoryEventName, message, }) => {
    useSendFullStoryEvent(fullStoryEventName);
    useTrackEvent(eventName);
    return (_jsxs(Fragment, { children: [_jsx(ModalContentHeader, { align: "center", children: _jsx(Text, { color: "neutral800", tag: "h1", type: "paragraph1ShortBold", children: "Something went wrong" }) }), _jsx(ModalContentBody, { align: "center", children: _jsx(Text, { color: "neutral700", tag: "p", type: "paragraph3", children: message }) }), _jsx(ModalContentFooter, { children: _jsx(Button, { href: "/app/get-help", children: "Get help" }, "get-help") })] }));
};

// @zapier/upsells@8.0.3 (1de7a616e)
